/**
 * Utility functions for domain checking
 */

// Allowed domains for Intercom chatbot display
const ALLOWED_DOMAINS = [
  'amiktechnologies.com',
  'amiktech.in', 
  'avvtech.ca',
  'localhost'
];

/**
 * Check if the current domain is in the allowed list for Intercom display
 * @returns {boolean} true if domain is allowed, false otherwise
 */
export const isDomainAllowedForIntercom = () => {
  if (typeof window === 'undefined') {
    return false; // Server-side rendering
  }
  
  const currentHost = window.location.hostname;
  
  // Check if current hostname matches any allowed domain
  return ALLOWED_DOMAINS.some(domain => {
    // Handle both exact matches and subdomains
    return currentHost === domain || currentHost.endsWith('.' + domain);
  });
};

/**
 * Get the current domain for debugging purposes
 * @returns {string} current hostname
 */
export const getCurrentDomain = () => {
  if (typeof window === 'undefined') {
    return 'server-side';
  }
  return window.location.hostname;
};
